import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';
import { BooleanValueProperty } from './properties/boolean-property.model';

export class FbAttachmentWidget extends Widget {
  constructor(data: any = {}) {
    super(data);
    this.title = 'Attachement';
    this.name = 'fb-attachment';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any = {}) {
    const properties = {
      required: new BooleanValueProperty(props.required || { title: 'Required' }),
      text: new TextProperty(props.text || { title: 'Attachment' }),
      content: new TextProperty(props.content || { title: 'Content' }),
      value: new TextProperty(props.value),
      hint: new TextProperty(props.hint || { title: 'Additional Instruction' }),
    };
    return properties;
  }

  isValid() {
    if (!this.isRequired()) {
      return true;
    }
    if (this.properties.value.value && this.properties.value.value.length > 0) {
      return true;
    }
    return false;
  }
}
